import React from 'react'
import { Helmet } from 'react-helmet'
import { createStore, forward } from 'effector'
import { useStore } from 'effector-react'
import { $pageCore } from './page'
import { RenderBlock } from '@rst/render-blocks/src/types'
import { isDevelopment } from '@rst/libs-ts'

const $meta = createStore<{ title: string; description: string }>({
	title: null,
	description: null,
})

forward({
	from: $pageCore.map((x: RenderBlock.BasicPage) => ({
		title: x?.title,
		description: x?.description,
	})),
	to: $meta,
})

export const Meta = () => {
	const meta = useStore($meta)

	return (
		// @ts-ignore
		<Helmet>
			<title>{meta?.title || ''}</title>
			<meta name="description" content={meta?.description || ''} />
			{isDevelopment && (
				<link
					rel="stylesheet"
					href="https://rsttur.ru/web/icons/sf-symbols/style.css"
				/>
			)}
		</Helmet>
	)
}
